import { Button, Card, CardContent, CardActions } from '@customink/pigment-react';
import { Collapse, styled } from '@mui/material';
import { MouseEventHandler } from 'react';
import { useAuth } from '~/contexts/Auth/AuthContext';
import { OrderSummary, OrderDetails } from '~/adapters/services/accounts/orders/types';
import { useOrderButtonConfigs } from '~/pages/OrderHistory/OrdersList/OrderCard/DesktopOrderContentRow/useOrderButtonConfigs';
import { Loader } from '~/components/Loader/loader';
import { OrderCardMedia } from '~/pages/OrderHistory/OrdersList/OrderCard/OrderCardMedia/OrderCardMedia';
import { OrderCardSummaryInfo } from '../OrderCardSummaryInfo/OrderCardSummaryInfo';
import { OrderDetail } from '../OrderDetail/OrderDetail';
import { OrderDetailToggle } from '../../../components/OrderDetailToggle';

interface OrderContentRowProps {
    order: OrderSummary;
    detailOpen: boolean;
    toggle: MouseEventHandler<HTMLElement>;
    singleDetail: boolean;
    isLoading: boolean;
    open: boolean;
    data?: OrderDetails;
}

const StyledCard = styled(Card)(({ theme }) => ({
    '&:hover': {
        boxShadow: 'none',
        borderColor: theme.palette.divider,
    },
}));

export function MobileOrderContentRow({
    order,
    detailOpen,
    singleDetail,
    toggle,
    isLoading,
    data,
    open,
}: OrderContentRowProps) {
    const { isImpersonatedExperience } = useAuth();
    const buttonConfigs = useOrderButtonConfigs(order, isImpersonatedExperience);

    return (
        <StyledCard size="small">
            <OrderCardMedia order={order} />
            <CardContent sx={{ marginTop: '12px' }}>
                <OrderCardSummaryInfo order={order} />
            </CardContent>
            <CardActions>
                {buttonConfigs.map((config) => (
                    <Button
                        fullWidth
                        key={config.type}
                        variant={config.variant}
                        href={config.href}
                        onClick={config.onClick}
                    >
                        {config.label}
                    </Button>
                ))}
                <OrderDetailToggle toggle={toggle} open={detailOpen} singleDetail={singleDetail} />
            </CardActions>
            <Collapse in={open && !singleDetail} unmountOnExit>
                {isLoading && <Loader title="Loading..." />}
                {data && <OrderDetail orderDetails={data} />}
            </Collapse>
        </StyledCard>
    );
}
